import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Accidents() {
  const [vehicles, setVehicles] = useState([]);
  useEffect(() => { api.get("/vehicles").then(({ data }) => setVehicles(data)); }, []);
  const vMap = Object.fromEntries(vehicles.map((v) => [v.id, v.plate_number]));
  return (
    <ResourcePage
      endpoint="/accidents"
      testidPrefix="accident"
      eyebrow="Operations"
      title="Vehicle Accidents"
      subtitle="Incident reports, insurance claims and police cases."
      ctaLabel="Report accident"
      fields={[
        { name: "vehicle_id", label: "Vehicle", type: "select", required: true,
          options: vehicles.map((v) => ({ value: v.id, label: v.plate_number })) },
        { name: "date", label: "Date", type: "date" },
        { name: "location", label: "Location" },
        { name: "driver", label: "Driver" },
        { name: "description", label: "Description", type: "textarea", required: true },
        { name: "estimated_cost", label: "Estimated cost (UGX)", type: "number" },
        { name: "police_case_no", label: "Police case #" },
        { name: "status", label: "Status", type: "select", default: "reported",
          options: ["reported", "claims_filed", "closed"] },
      ]}
      columns={[
        { key: "vehicle_id", label: "Vehicle", render: (i) => <Badge tone="slate">{vMap[i.vehicle_id] || "—"}</Badge> },
        { key: "date", label: "Date" },
        { key: "location", label: "Location" },
        { key: "driver", label: "Driver" },
        { key: "estimated_cost", label: "Est. cost", render: (i) => i.estimated_cost ? `UGX ${Number(i.estimated_cost).toLocaleString()}` : "—" },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "closed" ? "emerald" : i.status === "claims_filed" ? "blue" : "amber"}>{(i.status || "").replaceAll("_", " ")}</Badge> },
      ]}
      searchKeys={["location", "driver", "description"]}
    />
  );
}
